import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum PrimaryFoot {
	Right = 'right',
	Left = 'left',
}

export interface UserRating extends Record, AllowedActionable, Dateable {
	userId: number;
	user: models.user.User;
	author: models.user.User;

	hiddenScores: boolean;
	groupId: number;
	raterUserId: number;
	isPrimaryRating: boolean;
	primaryFoot?: string;
	suggestedPositionId: number;
	positionScores: PositionScore[];
	ratingScores: RatingScore[];
	ratingItems?: RatingInput[];
	maturityAdjustment: number;
}

export interface RatingInput {
	ratingItemId: number;
	value: number;
}

export interface PositionScore {
	value: number;
	maturityAdjustedValue: number;

	positionId: number;
	position?: models.position.Position;
}

export interface RatingScore {
	difference: number;
	inputValue: number;
	maturityAdjustedDifference: number;
	maturityAdjustedValue: number;
	ratingItem: RatingItem;
	ratingItemId: number;
	value: number;
}

export interface RatingItem {
	id: number;
	name: string;
	slug: string;
	category: string;
	categorySlug: string;
	description: string;
	shortDescription: string;
}
